// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xlWh","col":"styles_col__3QLlc","actions":"styles_actions__3lzYy","conflict":"styles_conflict__12J2c"};